import React, { Component } from 'react';
import Button from 'antd/lib/button';
import Tag from 'antd/lib/tag';
import message from 'antd/lib/message';
import api from '../api';

// Mirrors backend MessageStatus enum.
const STATUS_LABELS = {
  1: { label: 'GENERATED — scheduled', color: 'orange' },
  2: { label: 'SENT', color: 'green' },
  3: { label: 'SENDING', color: 'blue' },
  4: { label: 'FAILED', color: 'red' },
};

export default class SmsLogTool extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loaded: false,
      items: [],
      total: null,
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ loading: true });
    const res = await api.listSms();
    if (res && res.ok && res.data && Array.isArray(res.data.items)) {
      this.setState({ items: res.data.items, total: res.data.total, loaded: true });
    } else {
      message.error('Loading SMS log failed');
    }
    this.setState({ loading: false });
  };

  renderStatus = status => {
    const known = STATUS_LABELS[status];
    return known ? <Tag color={known.color}>{known.label}</Tag> : <Tag>{status}</Tag>;
  };

  renderItem = item => (
    <li key={item.id} className="tt-smslog-item">
      <div className="tt-smslog-meta">
        {this.renderStatus(item.status)}
        <span className="tt-smslog-receiver">{item.receiver}</span>
        <span className="tt-smslog-date">{item.sentDate ? new Date(item.sentDate).toLocaleString() : '—'}</span>
      </div>
      <div className="tt-smslog-details">
        {[item.accountName, item.template].filter(Boolean).join(' · ')}
      </div>
      <div className="tt-smslog-message">{item.message}</div>
    </li>
  );

  render() {
    const { loading, loaded, items, total } = this.state;

    return (
      <div className="tt-smslog-container" onMouseDown={e => e.stopPropagation()}>
        <div className="tt-smslog-header">
          <span className="tt-smslog-count">
            {loaded && total !== null
              ? `Showing latest ${items.length} of ${total}`
              : 'Loading…'}
          </span>
          <Button size="small" onClick={this.load} loading={loading}>
            Refresh
          </Button>
        </div>
        {loaded && items.length === 0 ? (
          <div className="tt-empty">No SMS messages logged yet</div>
        ) : (
          <ul className="tt-smslog-list">{items.map(this.renderItem)}</ul>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/test-tools/tools/SmsLogTool.js